var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 2.9L14.8 0.2C14.5 0.1 14.3 0 14 0C13.7 0 13.5 0.1 13.3 0.2L8.8 2.9C8.3 3.2 8 3.7 8 4.2V9.8C8 10.3 8.3 10.8 8.7 11.1L13.2 13.8C13.4 13.9 13.7 14 13.9 14C14.1 14 14.4 13.9 14.6 13.8L19.1 11.1C19.5 10.8 19.8 10.4 19.8 9.8V4.2C20 3.7 19.7 3.2 19.3 2.9ZM18 9.5L14 11.9L10 9.5V4.5L14 2.1L18 4.5V9.5ZM27.3 16.9L22.8 14.2C22.5 14.1 22.3 14 22 14C21.7 14 21.5 14.1 21.3 14.2L16.8 16.9C16.4 17.2 16.1 17.6 16.1 18.2V23.8C16.1 24.3 16.4 24.8 16.8 25.1L21.3 27.8C21.5 27.9 21.8 28 22 28C22.2 28 22.5 27.9 22.7 27.8L27.2 25.1C27.6 24.8 27.9 24.4 27.9 23.8V18.2C28 17.7 27.7 17.2 27.3 16.9ZM26 23.5L22 25.9L18 23.5V18.5L22 16.1L26 18.5V23.5ZM11.3 16.9L6.8 14.2C6.5 14.1 6.3 14 6 14C5.7 14 5.5 14.1 5.3 14.2L0.8 16.9C0.3 17.2 0 17.7 0 18.2V23.8C0 24.3 0.3 24.8 0.7 25.1L5.2 27.8C5.5 27.9 5.7 28 6 28C6.3 28 6.5 27.9 6.7 27.8L11.2 25.1C11.6 24.8 11.9 24.4 11.9 23.8V18.2C12 17.7 11.7 17.2 11.3 16.9ZM10 23.5L6 25.9L2 23.5V18.5L6 16.1L10 18.5V23.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksPage);
export default __webpack_public_path__ + "static/media/tasks-page.db88b60e1c6519fa7c7e83eebf5c6bd0.svg";
export { ForwardRef as ReactComponent };